import styled from 'styled-components';
import BootstrapTable from 'react-bootstrap-table-next';

export const Table = styled(BootstrapTable)``;
